export const GUEST_TOTAL_PAID='GUEST_TOTAL_PAID';
export const GET_PARTICULAR_GUEST_DATA='GET_PARTICULAR_GUEST_DATA';
export const SUCCESS_RESPONSE='SUCCESS_RESPONSE';
export const FAILURE_RESPONSE='FAILURE_RESPONSE';
export const LOADING='LOADING';
export const GET_ARCHIVED_GUESTS="GET_ARCHIVED_GUESTS";
export const RECENT_TRANSACTION='RECENT_TRANSACTION';
export const GET_FILTERED_BEDS_COUNT='GET_FILTERED_BEDS_COUNT';
export const GET_SELECTED_OCCUPANCY_TYPE='GET_SELECTED_OCCUPANCY_TYPE';

export const MONTHLY_INCOME_BY_BUILDING="MONTHLY_INCOME_BY_BUILDING";
export const GUESTPROFILE_PICTURE="GUESTPROFILE_PICTURE";
export const TODAYS_CHECKHOUT="TODAYS_CHECKHOUT";
